<div class="compose-container" *ngIf="ativo" [@slideInOut]>
  <div class="compose-card">
    <!-- Card Header -->
    <div class="card-header">
      <div class="header-info">
        <div class="compose-icon">
          <i class="fas fa-edit"></i>
        </div>
        <div class="compose-title">
          <h3 translate>{{'comunicado.novaMensagem.titulo'}}</h3>
        </div>
      </div>
      <button class="btn-close" (click)="cancelarInclusao()" [title]="'comunicado.novaMensagem.fechar' | translate">
        <i class="fas fa-arrow-left"></i>
        <span translate>{{'comunicado.novaMensagem.voltar'}}</span>
      </button>
    </div>

    <!-- Card Body -->
    <div class="card-body">
      <div class="form-container">
        <form class="compose-form" (ngSubmit)="salvarComunicado()">

        

        <!-- Recipients Section -->
        <div class="form-section">
          <label class="form-label required" translate>{{'comunicado.novaMensagem.destinatarios'}}</label>
          <div class="recipients-container">
            <div class="recipients-list" *ngIf="contatosSelecionados().length > 0">
              <div class="recipient-item" *ngFor="let destinatario of contatosSelecionados()" 
                [title]="destinatario.hint">
                <div class="recipient-avatar">
                  <i class="fas fa-user"></i>
                </div>
                <span class="recipient-name">{{destinatario.toTexto()}}</span>
                <button type="button" class="recipient-remove" (click)="removerDestinatario(destinatario)">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
            <div class="recipients-actions">
              <button type="button" class="btn-add-recipient" (click)="selecionarDestinatario()">
                <i class="fas fa-plus"></i>
                <span translate>{{'comunicado.novaMensagem.adicionarDestinatarios'}}</span>
              </button>
              <div class="recipients-bulk-actions">
                <button type="button" 
                        class="btn-bulk-action btn-add-all" 
                        (click)="adicionarTodosDestinatarios()"
                        [disabled]="contatosDisponiveis().length === 0"
                        [title]="'comunicado.novaMensagem.adicionarTodos' | translate">
                  <i class="fas fa-users"></i>
                  <i class="fas fa-plus"></i>
                </button>
                <button type="button" 
                        class="btn-bulk-action btn-remove-all" 
                        (click)="removerTodosDestinatarios()"
                        [disabled]="contatosSelecionados().length === 0"
                        [title]="'comunicado.novaMensagem.removerTodos' | translate">
                  <i class="fas fa-users"></i>
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Dealers Section -->
        <div class="form-section">
          <label class="form-label" translate>{{'comunicado.novaMensagem.dealers'}}</label>
          <div class="recipients-container">
            <div class="recipients-list" *ngIf="dealersSelecionados().length > 0">
              <div class="recipient-item" *ngFor="let dealer of dealersSelecionados()">
                <div class="recipient-avatar">
                  <i class="fas fa-building"></i>
                </div>
                <span class="recipient-name">{{dealer.toTexto()}}</span>
                <button type="button" class="recipient-remove" (click)="removerDealer(dealer)">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
            <div class="recipients-actions">
              <button type="button" class="btn-add-recipient" (click)="selecionarDealer()">
                <i class="fas fa-plus"></i>
                <span translate>{{'comunicado.novaMensagem.adicionarDealers'}}</span>
              </button>
            </div>
          </div>
        </div>

        <!-- Tipo de Envio Section -->
        <div class="form-section">
          <div class="form-group">
            <label class="form-label required" translate>{{'comunicado.novaMensagem.tipoEnvio'}}</label>
            <p-dropdown 
              [(ngModel)]="tipoEnvio"
              [options]="tipoEnvioOpcoes"
              name="tipoEnvio"
              optionLabel="label"
              optionValue="value"
              [placeholder]="'comunicado.novaMensagem.selecioneTipoEnvio' | translate"
              [showClear]="false"
              (onChange)="onTipoEnvioChange()"
              [style]="{'width':'100%' }">
              <ng-template pTemplate="selectedItem">
                <div class="tipo-envio-selected" *ngIf="tipoEnvio !== null">
                  <i [class]="TipoEnvioIcons[tipoEnvio]" style="margin-right: 8px;"></i>
                  <span>{{getTipoEnvioLabel()}}</span>
                </div>
              </ng-template>
              <ng-template let-opcao pTemplate="item">
                <div class="tipo-envio-item">
                  <i [class]="opcao.icon" style="margin-right: 8px;"></i>
                  <span>{{opcao.label}}</span>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
        </div>

        <!-- Tags Section -->
        <!-- <div class="form-section">
          <label class="form-label" translate>{{'comunicado.novaMensagem.marcadores'}}</label>
          <div class="tags-container">
            <div class="tags-list" *ngIf="marcadores.length > 0">
              <span class="tag-item" *ngFor="let marcador of marcadores">
                <i class="fas fa-tag"></i>
                {{marcador}}
                <button type="button" class="tag-remove" (click)="removerMarcador(marcador)">
                  <i class="fas fa-times"></i>
                </button>
              </span>
            </div>
            <div class="tag-input-container">
              <input 
                type="text" 
                class="tag-input" 
                (keyup.enter)="inserirMarcador($event)"
                placeholder="{{'comunicado.novaMensagem.marcadoresPlaceHolder' | translate}}">
              <button type="button" class="tag-add-btn">
                <i class="fas fa-plus"></i>
              </button>
            </div>
          </div>
        </div> -->

        <!-- Subject Field -->
        <div class="form-section">
          <div class="form-group">
            <label class="form-label required" translate>{{'comunicado.novaMensagem.tituloCampo'}}</label>
            <input 
              type="text" 
              class="form-input" 
              [(ngModel)]="titulo"
              name="titulo"
              placeholder="{{'comunicado.novaMensagem.tituloPlaceHolder' | translate}}"
              maxlength="255"
              (input)="onTituloChange()"
              asciiOnly
              (caracterInvalido)="onCaracterInvalidoTitulo($event)"
              required>
            <div class="title-footer">
              <div class="title-info">
                <span class="char-count" [class.char-limit-warning]="titulo.length > 200" [class.char-limit-error]="titulo.length >= 255">
                  {{titulo.length}}/255 {{'comunicado.novaMensagem.caracteres' | translate}}
                </span>
                <span class="char-limit-message" *ngIf="titulo.length >= 255">
                  {{'comunicado.novaMensagem.limiteCaracteres' | translate}}
                </span>
              </div>
              <div class="ascii-hint" [ngClass]="{'ascii-hint-warning': mostrarAvisoAsciiTitulo, 'ascii-hint-shake': mostrarAvisoAsciiTitulo}">
                <i class="fas fa-exclamation-triangle"></i>
                <span translate>{{'comunicado.validacao.apenasAscii'}}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Message Content -->
        <div class="form-section">
          <label class="form-label required" translate for="mensagem">{{'comunicado.novaMensagem.mensagem'}}</label>
          <div class="message-editor">
            <textarea 
              class="message-textarea" 
              id="mensagem"
              [(ngModel)]="mensagem"
              name="mensagem"
              [placeholder]="'comunicado.novaMensagem.digiteMensagem' | translate"
              rows="8"
              maxlength="998"
              (input)="onMensagemChange()"
              asciiOnly
              (caracterInvalido)="onCaracterInvalidoMensagem($event)"
              required></textarea>
            <div class="message-footer">
              <div class="message-info">
                <span class="char-count" [class.char-limit-warning]="mensagem.length > 900" [class.char-limit-error]="mensagem.length >= 998">
                  {{mensagem.length}}/998 {{'comunicado.novaMensagem.caracteres' | translate}}
                </span>
                <span class="char-limit-message" *ngIf="mensagem.length >= 998">
                  {{'comunicado.novaMensagem.limiteCaracteres' | translate}}
                </span>
              </div>
              <div class="ascii-hint" [ngClass]="{'ascii-hint-warning': mostrarAvisoAsciiMensagem, 'ascii-hint-shake': mostrarAvisoAsciiMensagem}">
                <i class="fas fa-exclamation-triangle"></i>
                <span translate>{{'comunicado.validacao.apenasAscii'}}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Attachments Section -->
        <div class="form-section">
          <div class="form-label-with-info">
            <label class="form-label" translate>{{'comunicado.novaMensagem.anexos'}}</label>
            <span class="file-size-limit-info">
              <i class="fas fa-info-circle"></i>
              <span translate>{{'comunicado.novaMensagem.limiteMaximo'}}</span>
            </span>
          </div>
          <div class="attachments-container">
            <div class="attachments-list" *ngIf="uploader.queue.length > 0">
              <div class="attachment-item" *ngFor="let item of uploader.queue">
                <div class="attachment-icon">
                  <i class="fas fa-file"></i>
                </div>
                <span class="attachment-name">{{item._file.name}}</span>
                <button type="button" class="attachment-remove" (click)="removerArquivo(item)">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
            
            <!-- Indicador de tamanho total -->
            <div class="file-size-indicator" *ngIf="uploader.queue.length > 0">
              <div class="size-info">
                <div class="size-text">
                  <span class="size-label">Tamanho total:</span>
                  <span class="size-value">{{getTamanhoTotalFormatado()}}</span>
                  <span class="size-limit">/ 10.00 MB</span>
                </div>
              </div>
              <div class="size-bar">
                <div class="size-bar-fill" [style.width.%]="getPorcentagemUsada()" 
                     [class.size-warning]="getPorcentagemUsada() > 80"
                     [class.size-danger]="getPorcentagemUsada() > 95"></div>
              </div>
            </div>
            
            <div class="file-upload-area">
              <input 
                type="file" 
                class="file-input" 
                ng2FileSelect 
                accept=".pdf,.doc,.docx,.xls,.xlsx,.txt" 
                [uploader]="uploader" 
                multiple>
              <div class="upload-placeholder">
                <i class="fas fa-cloud-upload-alt"></i>
                <span translate>{{'comunicado.novaMensagem.cliqueParaAdicionar'}}</span>
              </div>
            </div>
          </div>
        </div>
        </form>
      </div>

      <!-- Action Buttons -->
      <div class="form-actions">
        <div class="action-buttons">
          <button type="button" class="btn btn-cancel" (click)="cancelarInclusao()">
            <i class="fas fa-times"></i>
            <span translate>{{'comunicado.novaMensagem.cancelar'}}</span>
          </button>
          <button 
            type="button" 
            class="btn btn-send" 
            [disabled]="habilitaEnvio"
            [class.sending]="enviando"
            (click)="salvarComunicado()">
            <i class="fas" [ngClass]="enviando ? 'fa-spinner fa-spin' : 'fa-paper-plane'"></i>
            <span *ngIf="!enviando" translate>{{'comunicado.novaMensagem.enviar'}}</span>
            <span *ngIf="enviando" translate>{{'comunicado.novaMensagem.enviando'}}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Success Animation Overlay -->
  <div class="success-overlay" *ngIf="enviado" [@fadeInOut]>
    <div class="success-content">
      <div class="success-icon">
        <i class="fas fa-check-circle"></i>
      </div>
      <h3 translate>{{'comunicado.novaMensagem.comunicadoEnviado'}}</h3>
      <p translate>{{'comunicado.novaMensagem.comunicadoEnviadoSucesso'}}</p>
    </div>
  </div>
</div>

<app-filtro-dealers 
  [visible]="mostrarModalDestinatarios"
  [dealers]="contatos"
  [headerTitle]="'comunicado.novaMensagem.selecioneDestinatarios'"
  [filterPlaceholder]="'comunicado.novaMensagem.filtrarDestinatarios'"
  [modalWidth]="'600px'"
  [showHints]="true"
  (visibleChange)="fecharModalDestinatarios()"
  (dealerSelected)="adicionarDestinatario($event)">
</app-filtro-dealers>

<app-filtro-dealers
  [visible]="mostrarModalDealers"
  [dealers]="dealers"
  [headerTitle]="'comunicado.novaMensagem.selecioneDealers'"
  [filterPlaceholder]="'comunicado.novaMensagem.filtrarDealers'"
  [modalWidth]="'600px'"
  [showHints]="false"
  (visibleChange)="fecharModalDealers()"
  (dealerSelected)="adicionarDealer($event)">
</app-filtro-dealers>